import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const CareersSection = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      .careers-section {
        width: 100%;
        background: linear-gradient(160deg, #0d7a93 0%, #095c70 100%);
        padding: 40px 20px;
        box-sizing: border-box;
      }

      .careers-container {
        max-width: 1100px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        gap: 40px;
      }

      .careers-image-wrap {
        flex: 0 0 260px;
        max-width: 260px;
      }

      .careers-image-frame {
        width: 100%;
        aspect-ratio: 4 / 3;
        border-radius: 12px;
        overflow: hidden;
        box-shadow: 0 12px 30px rgba(0, 0, 0, 0.18);
      }

      .careers-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }

      .careers-text {
        flex: 1 1 380px;
        min-width: 0;
      }

      .careers-eyebrow {
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 1.6px;
        text-transform: uppercase;
        color: #e8b923;
        margin: 0 0 8px 0;
      }

      .careers-heading {
        font-size: 22px;
        font-weight: 800;
        font-family: 'Montserrat', sans-serif;
        color: #ffffff;
        margin: 0 0 12px 0;
        letter-spacing: -0.2px;
      }

      .careers-paragraph {
        font-size: 14px;
        font-weight: 400;
        color: #dfeff5;
        line-height: 1.65;
        margin: 0 0 20px 0;
        text-align: left;
        max-width: 520px;
      }

      .careers-btn {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        background: #e8b923;
        color: #0f172a;
        padding: 11px 22px;
        border: none;
        border-radius: 6px;
        cursor: pointer;
        font-size: 13.5px;
        font-weight: 700;
        letter-spacing: 0.2px;
        transition: background 0.25s ease, transform 0.25s ease;
      }

      .careers-btn:hover {
        background: #c9960c;
        transform: translateY(-2px);
      }

      /* ===== Responsive ===== */
      @media (max-width: 900px) {
        .careers-image-wrap {
          flex: 0 0 220px;
          max-width: 220px;
        }
        .careers-heading {
          font-size: 20px;
        }
      }

      @media (max-width: 768px) {
        .careers-container {
          flex-direction: column;
          text-align: center;
          gap: 24px;
        }
        .careers-image-wrap {
          flex: 0 0 auto;
          max-width: 220px;
          margin: 0 auto;
        }
        .careers-text {
          flex: 1 1 auto;
        }
        .careers-paragraph {
          text-align: center;
          max-width: 480px;
          margin: 0 auto 20px auto;
        }
        .careers-heading {
          font-size: 19px;
        }
      }

      @media (max-width: 480px) {
        .careers-section {
          padding: 32px 16px;
        }
        .careers-image-wrap {
          max-width: 180px;
        }
        .careers-heading {
          font-size: 17px;
        }
        .careers-paragraph {
          font-size: 13px;
        }
        .careers-btn {
          padding: 10px 18px;
          font-size: 12.5px;
        }
      }

      @media (max-width: 360px) {
        .careers-image-wrap {
          max-width: 150px;
        }
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  return (
    <section className="careers-section">
      <div className="careers-container">
        {/* Left: Image */}
        <div className="careers-image-wrap">
          <div className="careers-image-frame">
            <img src="/image/career.jpg" alt="Careers" className="careers-image" />
          </div>
        </div>

        {/* Right: Text Content */}
        <div className="careers-text">
          <p className="careers-eyebrow">Join Our Team</p>
          <h2 className="careers-heading">Careers</h2>
          <p className="careers-paragraph">
            If you share our love for engineering and innovation, we'll provide
            you with all the tools and platforms to navigate your growth journey.
            Join us to engineer the change you envision!
          </p>
          <button className="careers-btn" onClick={() => navigate("/careerpage")}>
            Explore Opportunities
          </button>
        </div>
      </div>
    </section>
  );
};

export default CareersSection;